import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgNeckGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M36.983 20.387v-.267A3.746 3.746 0 0 0 40 16.453c0-1.821-1.3-3.33-3.017-3.666V11h-1.45v9.387c0 3.376-6.869 7.6-9.56 8.968a3.829 3.829 0 0 1-3.992-.023c-2.645-1.346-9.514-5.57-9.514-8.945V11h-1.45v1.787A3.746 3.746 0 0 0 8 16.453c0 1.81 1.3 3.33 3.017 3.667v.267c0 2.657 2.738 5.279 5.407 7.216.15 1.358.208 4.096-1.404 6.15-1.15 1.462-2.96 2.309-5.372 2.54l.139 1.44c2.83-.267 4.977-1.3 6.381-3.087 1.532-1.938 1.81-4.316 1.787-6.01 1.624 1.056 2.994 1.764 3.342 1.95a5.259 5.259 0 0 0 5.406.034c.337-.174 1.52-.789 2.97-1.706-.034 1.694.28 3.899 1.718 5.732 1.404 1.787 3.585 2.82 6.486 3.086l.139-1.438c-2.483-.232-4.328-1.091-5.488-2.541-1.497-1.903-1.508-4.363-1.334-5.848 2.773-1.972 5.79-4.734 5.79-7.518Zm1.567-3.934a2.28 2.28 0 0 1-1.567 2.158v-4.328a2.29 2.29 0 0 1 1.567 2.17Zm-29.1 0c0-1.01.662-1.856 1.567-2.17v4.328a2.28 2.28 0 0 1-1.567-2.158Z",
    fill: "currentColor"
  }));
}

export { SvgNeckGlyph as default };
